export default {
  'aiVectors.form.openAIVectorStoreId': 'ID de Vector Store de OpenAI',
  'aiVectors.form.isManaged': 'Gestionado',

  'aiVectors.files.title': 'Documentos de entrenamiento',
  'aiVectors.files.add': 'Agregar documentos',
  'aiVectors.files.count': '{count, plural, one {# documento} other {# documentos}}',
  'aiVectors.files.empty': 'Aún no se han agregado documentos a este vector.',
  'aiVectors.files.loading': 'Cargando documentos…',
  'aiVectors.files.uploading': 'Subiendo…',
  'aiVectors.files.uploadError': 'No se pudo procesar el archivo.',
  'aiVectors.files.tooLarge': 'El archivo supera el límite de {max} MB.',
  'aiVectors.files.dragText': 'Arrastra archivos aquí o haz clic para subir',
  'aiVectors.files.dragHint':
    'PDF, Word, Excel, CSV, TXT, MD, JSON o imágenes · hasta {max} MB cada uno',
  'aiVectors.files.synced': 'Sincronizado',
  'aiVectors.files.pendingSync': 'Sincronizando',
  'aiVectors.files.syncFailed': 'Error de sincronización',
  'aiVectors.files.lastSyncAttempt': 'Último intento',
  'aiVectors.files.retrySync': 'Reintentar sincronización',
  'aiVectors.files.retryAll': 'Reintentar sincronización',
  'aiVectors.files.retryAllHint':
    '{count, plural, one {# documento pendiente de sincronizar} other {# documentos pendientes de sincronizar}}',
  'aiVectors.files.readonlyHint': 'Edita el vector para agregar o quitar documentos.',
};
